<template lang="pug">
.game-calibration
  .game-calibration__left
    .game-calibration__account-name(:title="account.username") {{ account.username }}
    .game-calibration__account-id {{ account.id }}
  .game-calibration__right(v-if="calibrationData && calibrationData.isCalibrated")
    .game-calibration__rank {{ ratingGroupTitle }}
    RatingTooltip
      img(:src='require(`~/assets/img/icons/new-rating.svg`)')
      span.game-calibration__rating {{ Math.floor(account.ratings.default) }}
  .game-calibration__right.game-calibration__right--left(v-else-if="calibrationData && !calibrationData.isCalibrated")
    .game-calibration__right-top
      .game-calibration__rank.game-calibration__rank--calibration {{ $t('calibration') }}
      RatingTooltip
        img(:src='require(`~/assets/img/icons/new-rating.svg`)')
        span.game-calibration__rating {{ Math.floor(account.ratings.default) }}
    .game-calibration__line(v-if="calibrationData && !calibrationData.isCalibrated")
      .game-calibration__line-dot(v-for="i in 10" :key="`calibration_${game.name}_${i}`" :class="{'--green': isWin(calibrationData.tournaments[i - 1]), '--red': isWin(calibrationData.tournaments[i - 1]) === false}")
</template>

<script>
import GamesService from '@/services/GamesService'
import RatingTooltip from '~/components/RatingTooltip/RatingTooltip'

export default {
  name: 'GameCalibration',
  components: { RatingTooltip },
  props: {
    account: {
      type: Object,
      required: true
    },
    game: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      calibrationData: undefined
    }
  },

  computed: {
    ratingGroup () {
      return GamesService.getRatingGroupObject(Math.floor(this.account?.ratings?.default))
    },

    ratingGroupTitle () {
      return this.ratingGroup?.title
    }
  },

  mounted () {
    this.loadCalibrationData()
  },

  methods: {
    isWin (t) {
      return t?.is_win
    },

    loadCalibrationData () {
      this.$axios.get(`/games/${this.game.name}/account/calibration`)
        .then((response) => {
          this.calibrationData = response.data?.data
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.game-calibration {
  display: grid;
  align-items: center;
  grid-template-columns: 2fr 3fr;
  grid-gap: 24px;
  width: 100%;
  padding: 16px;
  background-color: $blue-grey70;
  border-radius: 8px;

  &__account {
    &-name {
      color: $white;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
    }

    &-id {
      color: $blue-grey10;
      font-size: 14px;
      font-weight: 500;
      line-height: 140%;
      margin-top: 8px;
    }
  }

  &__right {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-direction: column;

    &--left {
      align-items: flex-start;
    }

    &-top {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  &__rating {
    color: $blue-grey10;
    font-size: 14px;
    font-weight: 500;
    line-height: 120%;
  }

  &__rank {
    display: flex;
    padding: 6px 12px;
    justify-content: center;
    align-items: center;
    background: $orange70;
    border-radius: 100px;
    border: 1px solid $white;
    color: $white;
    font-size: 14px;
    font-weight: 700;
    line-height: 120%;
    text-transform: uppercase;

    &--calibration {
      background: $blue-grey60;
    }
  }

  &__line {
    display: grid;
    grid-template-columns: repeat(10, 8px);
    grid-gap: 4px;
    align-items: center;
    margin: 12px 0 0;

    @media (min-width: $breakpointTablet) {
      grid-gap: 14px;
      grid-template-columns: repeat(10, 16px);
    }

    &-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: $blue-grey20;

      @media (min-width: $breakpointTablet) {
        width: 16px;
        height: 16px;
      }

      &.--green {
        background: $green60;
      }

      &.--red {
        background: $pink60;
      }
    }
  }
}
</style>
